import React from "react";
import Report from "../../../components/user/report/reportDetail";
import Layout from "../../../components/layouts/verticalLayout";
import { useParams } from "react-router-dom";

const ReportDetailPage = () => {
  let { uuid } = useParams();
  return <Layout body={<Report uuid={uuid} report />} />;
};

ReportDetailPage.propTypes = {};

export default ReportDetailPage;
